export const UpcomingWebinarsSlider = function () {
	this.selectors = {
		itemsWrapper: jQuery('.upcoming-webinars .ecs-posts'),
	};

	this.state = {
		owl: null,
	};

	this.config = {
		owl: {
			center: true,

			items: 1,

			loop: true,

			stagePadding: 48,

			margin: 18,

			nav: false,

			dots: true,

			autoplay: true,

			autoplayTimeout: 6000,

			smartSpeed: 1000,

			dragEndSpeed: 1000,

			autoplayHoverPause: false,
		},
	};

	this.init = () => {
		this.owlInit();

		this.addEventListeners();
	};

	this.addEventListeners = () => {
		jQuery(window).resize(this.windowResizeHandler);
	};

	this.windowResizeHandler = () => {
		jQuery(window).width() >= 768 ? this.destroyOwl() : this.createOwl();
	};

	this.owlInit = () => {
		if (jQuery(window).width() < 768) {
			this.createOwl();
		}
	};

	this.createOwl = () => {
		const $itemsWrapper = this.selectors.itemsWrapper;

		if ($itemsWrapper.length < 1) {
			return;
		}

		const owl = this.state.owl;

		if (owl) {
			return;
		}

		$itemsWrapper.addClass('owl-carousel');

		this.state.owl = $itemsWrapper.owlCarousel(this.config.owl);
	};

	this.destroyOwl = () => {
		const owl = this.state.owl;

		if (!owl) {
			return;
		}

		owl.trigger('destroy.owl.carousel');

		this.state.owl = null;

		this.selectors.itemsWrapper.removeClass('owl-carousel');
	};
};
